module.exports = __webpack_public_path__ + "static/man-boy-square.095f6fae.jpg";